export default "__VITE_ASSET__CldeUyu9__"